import { render, staticRenderFns } from "./TrGallery.vue?vue&type=template&id=2aef42cc&"
import script from "./TrGallery.vue?vue&type=script&lang=js&"
export * from "./TrGallery.vue?vue&type=script&lang=js&"
import style0 from "./TrGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports